<!-- Display do resumo -->
<!-- VAZIO -->
<div *ngIf="!selectedService">
  <div class="container display-sign empty"></div>
</div>
<!-- VAZIO -->

<div class="display-body" *ngIf="selectedService">
  <div *ngIf="loading" style="height: 70vh;">
    <app-loading-page></app-loading-page>
  </div>
  <!-- PENDÊNCIA -->
  <ng-container *ngIf="!loading">
    <div class="d-flex align-items-center justify-content-end">
      <!-- BOTÕES -->
      <div class="d-flex">
        <a [routerLink]="'/services/list/edit/' + selectedService?.id">
          <button class="btn btn-outline-primary d-flex justify-content-center align-items-center p-4 mr-3 ml-3"
            style="height: 32px; font-size: 20px">
            EDITAR
          </button>
        </a>
        <button class="btn btn-primary d-flex justify-content-center align-items-center p-4 mr-4 ml-3"
          (click)="updateStatus(pendingStatusEnum.Approved)" style="height: 32px; font-size: 20px">
          CONFIRMAR
        </button>
      </div>
      <!-- BOTÕES -->
    </div>
    <!-- PENDÊNCIA -->

    <!-- INFO BOX 1 -->
    <div class="mt-3 info-box">
      <div class="d-flex flex-column" style="gap: 16px">
        <!-- CADASTRO E RESPONSÁVEL -->
        <div class="d-flex">
          <div class="d-flex flex-column col-6 p-0">
            <h4 style="color: var(--gray-base)">Data de Cadastramento</h4>
            <span>{{ selectedService?.createdAt | date: 'dd/MM/yyyy HH:mm' }}</span>
          </div>
          <div class="d-flex flex-column col-6 p-0">
            <h4 class="text-muted">Responsável</h4>
            <span>{{
              selectedService?.responsibleMember?.user?.firstName + ' ' +
              selectedService?.responsibleMember?.user?.lastName
              }}</span>
          </div>
        </div>
        <!-- CADASTRO E RESPONSÁVEL -->

        <!-- VÍNCULOS -->
        <div class="d-flex">
          <div class="d-flex flex-column col-6 p-0">
            <h4 style="color: var(--gray-base)">Vínculo</h4>
            <span>{{ selectedService?.contract?.name ? selectedService?.contract.name : 'Sem vínculo contratual'
              }}</span>
          </div>
        </div>
        <!-- VÍNCULOS -->

        <!-- CUSTO -->
        <!-- <div class="invested-amount">
        <span> {{ selectedService?.type == signTypeEnum.Vertical ? 'Valor da Placa' : 'Valor Investido' }} </span>
        <span class="money-text">{{ selectedService?.cost | currency:'BRL':'R$' }}</span>
      </div> -->

        <!-- CUSTO -->
      </div>
    </div>
    <!-- INFO BOX 1 -->

    <!-- INFO BOX 2 -->
    <div class="mt-4 info-box">
      <div class="d-flex flex-column" style="gap: 16px">
        <!-- LOCALIZAÇÃO -->
        <div class="d-flex">
          <div class="d-flex flex-column">
            <h4 style="color: var(--gray-base)">Localização</h4>
            <span>{{
              (selectedService?.address?.road ? selectedService?.address?.road + ', ' : '') +
              (selectedService?.address?.road
              ? selectedService?.address?.house_number
              ? selectedService?.address?.house_number + ' - '
              : 's/ nº - '
              : '') +
              (selectedService?.address?.suburb ? selectedService?.address?.suburb + ', ' : '') +
              (selectedService?.address?.city ? selectedService?.address?.city : '') +
              (selectedService?.address?.postcode ? ', ' + selectedService?.address?.postcode : '')
              }}</span>
          </div>
        </div>
        <!-- LOCALIZAÇÃO -->

      </div>
    </div>

    <!-- INFO BOX 2 -->

    <!-- INFO BOX 3 -->
    <div class="mt-4 info-box">
      <!-- HVD -->
      <div class="d-flex" *ngFor="let type of selectedService?.types">
        <!-- BOX NUMBER -->
        <div class="d-flex flex-column" style="gap: 16px">
          <div class="item-number mr-3">
            <p class="m-0 text-primary">{{ type['itemNumber'] }}</p>
          </div>
          <h4 class="text-muted">{{'Quantidade: ' + type.quantity}}</h4>
        </div>
        <!-- BOX NUMBER -->

        <div class="col-9">

          <!-- INFORMAÇÕES VERTICAL -->
          <ng-container>
            <h4 class="mb-2" style="color: var(--gray-base)">Tipo de Serviço</h4>
            <p class="mb-3">{{ type['name'] }}</p>
          </ng-container>
          <!-- INFORMAÇÕES VERTICAL -->
        </div>
      </div>
      <!-- HVD -->

      <!-- INFO BOX 3 -->

      <div class="d-flex flex-column mt-4">
        <div class="d-flex flex-column">
          <div class="col-12 p-0"
            *ngFor="let situation of [imageSituationEnum?.After, imageSituationEnum?.Before]; let i = index"
            [ngClass]="{ 'mb-4': i == 0 }">
            <h3 class="mb-3" style="color: var(--gray-base); font-weight: 400">
              {{ i ? 'Foto da Sinalização' : 'Foto do Local' }}
            </h3>
            <div class="d-flex mt-2" style="overflow: auto">
              <div *ngFor="let file of selectedService.files; index as indexImg">
                <ng-container *ngIf="
                (situation == imageSituationEnum?.Before && file.situation == imageSituationEnum?.Before) ||
                (situation == imageSituationEnum?.After && file.situation == imageSituationEnum?.After)
              ">
                  <div class="box-img-list cursor-pointer" (click)="downloadFileSign(file.url)">
                    <div *ngIf="file" class="position-relative img-box">
                      <img [src]="file.url" class="list-image-upload" />
                      <div class="size-file">
                        <h4 style="color: white; pointer-events: none">
                          {{ file.file.size / (1024 * 1024) | number: '1.2-2' }}MB
                        </h4>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>

              <ng-container *ngIf="getImageEmpty(situation)">
                <div class="box-img-list"></div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <!-- BOTÃO PÁGINA DE DETALHES -->
      <a class="d-flex align-items-center justify-content-end mt-4 btn-popup"
        (click)="serviceDetailRouting(selectedService)" style="font-weight: 600; font-size: 14px; cursor: pointer">
        VER SERVIÇO <i class="fas fa-angle-right mr-0 ml-1" style="font-size: 20px"></i>
      </a>
      <!-- BOTÃO PÁGINA DE DETALHES -->
    </div>
  </ng-container>
  <!-- Modal de nova ocorrência -->
  <app-occurrence-creation-modal #occurrenceCreationModal></app-occurrence-creation-modal>
  <!-- /Modal de nova ocorrência -->
